var _style, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "2701.9px",
    height: "2434.9px",
    viewBox: "0 0 2701.9 2434.9",
    style: {
      enableBackground: "new 0 0 2701.9 2434.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F4F4F4;}\r\n\t.st2{fill:#231815;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2513.8,1576.6H188.1c-26.7,0-48.3-21.6-48.3-48.3V192.6c0-26.7,21.6-48.3,48.3-48.3h2325.6 c26.7,0,48.3,21.6,48.3,48.3v1335.7C2562.1,1555,2540.5,1576.6,2513.8,1576.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2665.8,1693.5v104.6c0,120.6-97.8,178.4-218.4,178.4h-684.9v233.1l125.4,149.6c20.7,14.7,7,40.9-21.4,40.9 h-1031c-28.4,0-42.1-26.2-21.4-40.9l125.4-149.6v-233.1H254.6c-120.6,0-218.4-57.8-218.4-178.4v-104.6H2665.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2535.1,34.3H166.8C94.6,34.3,36.1,92.8,36.1,165v1528.6h2629.6V165C2665.8,92.8,2607.3,34.3,2535.1,34.3z  M2562.1,1528.3c0,26.7-21.6,48.3-48.3,48.3H188.1c-26.7,0-48.3-21.6-48.3-48.3V192.6c0-26.7,21.6-48.3,48.3-48.3h2325.6 c26.7,0,48.3,21.6,48.3,48.3L2562.1,1528.3L2562.1,1528.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2535.1,24.3H166.8C89.2,24.3,26.1,87.4,26.1,165v1518.6v20v94.6c0,61,13.8,88.4,56.9,131.5 s110.5,56.9,171.5,56.9h674.9V2206l-122.3,145.9c-11.1,8.4-15.5,21-11.7,33.1c4.8,15.1,20.9,25.2,40,25.2h1030.9 c19.1,0,35.2-10.1,40-25.2c3.8-12.1-0.6-24.6-11.7-33.1L1772.4,2206v-219.4h674.9c61,0,128.4-13.8,171.5-56.9s56.9-70.5,56.9-131.5 v-94.6v-20V165C2675.8,87.4,2612.7,24.3,2535.1,24.3z M1882,2367.4c3.3,2.4,7,6.3,5.3,11.5c-1.7,5.4-9,11.3-21,11.3H835.5 c-11.9,0-19.2-5.8-21-11.3c-1.7-5.2,2-9.1,5.3-11.5l1.1-0.7l123.2-147.1h813.6l123.2,147.1L1882,2367.4z M1752.4,2199.6H949.5 v-213.1h802.9V2199.6z M2655.8,1798.1c0,114.9-93.5,168.4-208.4,168.4h-674.9h-843H254.6c-114.9,0-208.4-53.5-208.4-168.4v-94.6 h2609.6V1798.1z M46.1,1683.5V165c0-66.5,54.1-120.6,120.6-120.6h2368.4c66.5,0,120.6,54.1,120.6,120.6v1518.6L46.1,1683.5 L46.1,1683.5z M2513.8,134.3H188.1c-32.1,0-58.3,26.1-58.3,58.3v1335.7c0,32.1,26.1,58.3,58.3,58.3h2325.6 c32.1,0,58.3-26.1,58.3-58.3V192.6C2572.1,160.5,2545.9,134.3,2513.8,134.3z M2552.1,1528.3c0,21.1-17.2,38.3-38.3,38.3H188.1 c-21.1,0-38.3-17.2-38.3-38.3V192.6c0-21.1,17.2-38.3,38.3-38.3h2325.6c21.1,0,38.3,17.2,38.3,38.3L2552.1,1528.3L2552.1,1528.3z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 1350.9,
    cy: 1824.7,
    r: 59.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.2574ce1177ef96b422ab3908d3c77251.svg";
export { ForwardRef as ReactComponent };